<template>
  <v-container fluid class="comms-message-container pa-0">
    <v-row>
      <v-col cols="4" class="px-0">
        <CommsMessageListing
          @add="handleAddMessage"
          @select="handleSelectMessage"
          :groups="groups"
          :locations="locations"
          :refresh="refresh"
        ></CommsMessageListing>
      </v-col>
      <v-col cols="8">
        <CommsMessageDetails
          v-if="message"
          :message-id="message.messageId"
          :is-draft="message.isDraft"
          :groups="groups"
          :locations="locations"
          @delete="handleDeleteMessage"
          @copy="handleCopyMessage"
          @edit="handleEditMessage"
          @send="handleSendMessage"
        ></CommsMessageDetails>
      </v-col>
    </v-row>

    <CommsMessagePopup
      v-if="groups && locations"
      :message="messageModify"
      :open="popup"
      :action="action"
      :groups="groups"
      :locations="locations"
      @close="handleClosePopup"
    ></CommsMessagePopup>
  </v-container>
</template>

<script>
import {
  saveMessage,
  getGroups,
  getLocations,
} from "@/services/communication/communication.service";

export default {
  name: "CommsMessages",
  components: {
    CommsMessageListing: () =>
      import("@/components/communication/CommsMessageListing"),
    CommsMessageDetails: () =>
      import("@/components/communication/CommsMessageDetails"),
    CommsMessagePopup: () =>
      import("@/components/communication/CommsMessagePopup"),
  },
  props: {},
  data: () => ({
    message: null,
    messageModify: null,
    refresh: new Date().toISOString(),
    popup: null,
    action: null,
    processing: false,
    failed: false,
    groups: null,
    locations: null,
  }),
  async mounted() {
    let promiseResults = await Promise.all([getGroups(), getLocations()]);
    this.groups = promiseResults[0];
    this.locations = promiseResults[1];
  },
  methods: {
    handleSelectMessage(message) {
      this.message = message;
    },
    handleAddMessage() {
      this.action = "add";
      this.popup = new Date().toISOString();
    },
    handleDeleteMessage() {
      this.refresh = new Date().toISOString();
    },
    handleCopyMessage(message) {
      this.action = "copy";
      this.messageModify = message;
      this.popup = new Date().toISOString();
    },
    handleEditMessage(message) {
      this.action = "edit";
      this.messageModify = message;
      this.popup = new Date().toISOString();
    },
    async handleSendMessage(message) {
      this.processing = true;
      message.isDraft = false;
      let params = {
        message: message,
      };

      try {
        await saveMessage(params);
      } catch (error) {
        console.error(error);
        this.failed = true;
      } finally {
        this.processing = false;
        this.refresh = new Date().toISOString();
      }
    },
    handleClosePopup() {
      this.refresh = new Date().toISOString();
      this.popup = null;
    },
  },
};
</script>

<style scoped></style>
